import React from 'react';

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { getBaseSlugFromPath } from 'utils'

import AlertBanner from 'components/alerts/alert-banner'

import { MainContext } from 'context'

const MeetingsList = props => {
    const {
        stakeholder,
        allMeetings,
        match,
        allProjects
    } = props

    const {
        account
    } = this.context

    const meetingsIds = stakeholder.meetings ? [...stakeholder.meetings] : []

    stakeholder.organised_meetings && stakeholder.organised_meetings.forEach(meetingId => {
        if(meetingsIds.indexOf(meetingId) == -1){
            meetingsIds.push(meetingId)
        }
    })

    const meetingObjects = meetingsIds.map(meetingId => {
        const meeting = allMeetings[meetingId]

        return meeting ? meeting : null
    })

    meetingObjects.sort((a,b) => {
        const aStartDate = a.start_date ? a.start_date : 'zzz'
        const bStartDate = b.start_date ? b.start_date : 'zzz'

        return bStartDate.localeCompare(aStartDate)
    })

    return (
        <div className='meetings-list'>
            { (!stakeholder.meetings || !stakeholder.meetings.length) ?
                <AlertBanner
                    title={`No meetings`} 
                    body={`This stakeholder hasn't been in any meetings.`}
                />				
            : 
                <ul className="headertab-list no-padding">
                    { meetingObjects.map(meeting => {
                        if(!meeting){
                            return null
                        }

                        const project = allProjects[meeting.project_id]

                        if(!project){
                            return null
                        }

                        let subtitle = project.name
                        let title = moment(meeting.start_date).format('MMM Do')

                        if(stakeholder.organised_meetings && stakeholder.organised_meetings.indexOf(meeting.id) !== -1){
                            title += ' (Organiser)'
                        }

                        if(meeting.contact_type_id){
                            const contactType = account.contact_types.find(contactTypeObject => {
                                return contactTypeObject.id == meeting.contact_type_id
                            })

                            if(contactType){
                                subtitle += ' • '+contactType.name
                            }
                        }

                        const url = getBaseSlugFromPath(match.url)+'/projects/'+project.slug+'/meetings?meeting='+meeting.id

                        return (
                            <li key={meeting.id}>
                                <Link to={url}>
                                    <div className="list-item-content">
                                        <h4>
                                            <em>
                                                { title }
                                            </em>
                                            <span>
                                                { subtitle }
                                            </span>
                                        </h4>
                                    </div>
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            }
        </div>
    )
};

const mapStateToProps = state => {
	return {
		allMeetings: state.account.entities.meetings,
		allProjects: state.account.entities.projects
	}
}

export default withRouter(connect(mapStateToProps, {})(MeetingsList))

MeetingsList.contextType = MainContext